/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedproducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_products = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedproducts = this.getproducts();

    viewedproducts = viewedproducts.filter((/** @type {string} */ id) => id !== productId);
    viewedproducts.unshift(productId);
    viewedproducts = viewedproducts.slice(0, this.#MAX_products);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedproducts));
  }

  static clearproducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getproducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
